export const initialAbility = [
    {
        action: 'READ',
        subject: 'home'
    }
]

export const _ = undefined
